import { useContext, useEffect, useState } from "react";
import { Button, Container, Row, Spinner } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { FaBoxOpen } from "react-icons/fa";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { FiltersProps } from "../../../../@types";
import { PaginationList } from "../../../../components/pagination";
import { IMaterial } from "../../../../models/IMaterial";
import { listDiscipline } from "../../../../services/discipline.service";
import { removeFavorite } from "../../../../services/favorites.service";

import UsuarioContext from "../../../../../context/userContext/context";
import handleCardAgroup from '../../../../utils/handleCardAgroup/handleCardAgroup';
import { ListFilters } from "../../components/list-filters";
import { ListContent, NotFound } from "./styles";
import { CardCourse } from "../../../../components/card-course";
import { listCourses } from "../../../../services/courses.service";

export const CoursesList = (): JSX.Element => {
    const { t: translation } = useTranslation();
    const { user } = useContext(UsuarioContext);

    const [hashNews, setHashNews] = useState<IMaterial[][]>([])
    const [totalItens, setTotalItens] = useState(0)
    const [currentPage, setCurrentPage] = useState(1)
    const [loading, setLoading] = useState<boolean>(false)
    const [haveSheetFile, setHaveSheetFile] = useState<boolean>(false)
    const [sheetLink, setSheetLink] = useState<string>("")

    const [filters, setFilters] = useState<FiltersProps>({});

    const queryParams = new URLSearchParams(window.location.search)
    const search = queryParams.get("search")

    let history = useHistory();

    useEffect(() => {
        if (hashNews.length) {
            return;
        }

        if(search){
            setLoading(true);
            return;
        }

        setLoading(true);
        listCourses().then(resp => {
            setTotalItens(resp.count);
            setHashNews(handleCardAgroup(resp.results, 3))
            setHaveSheetFile(resp.spreadsheet !== "" ? true : false)
            setSheetLink(resp.spreadsheet)
        })
    }, [])

    const handleCourseDetails = (event?: any) => {
        if (!event.tab) { 
            history.push('/courses/' + event.material.id);
        } else { 
            window.open('/courses/' + event.material.id)
        }        
    }

    const handleFilters = (event?: any) => {
        setFilters({ ...event, 'page': 1 });
    }

    const handlePageChange = (event?: any) => {
        setFilters({ ...filters, 'page': event });
    }

    const handleRemoveFavorite = (id: number) => {
        removeFavorite(id).then(() => {
            toast.success('Disciplina removida com sucesso!', { 
              position: "bottom-center",
            })
        }).catch((err: any) => {
            toast.error('Ocorreu um erro ao remover esta disciplina.')
        })
    }

    useEffect(() => {
        if (Object.keys(filters).length > 0 && 
            (filters.q !== "" || filters.page ||
            (filters.knowledge && filters.knowledge.length !== 0) || 
            (filters.modalities && filters.modalities.length !== 0) || 
            (filters.categories && filters.categories !== ""))
            ) {
            setLoading(true);
            listCourses(filters).then(resp => {
                setTotalItens(resp.count);
                setHashNews(handleCardAgroup(resp.results, 3))
                if (filters && filters.page) {
                    setCurrentPage(filters.page);
                }
                setLoading(false);
            }).catch(() => {
                setLoading(false);
            })
        }
    }, [filters])

    return (
        <Container fluid>
            <Row className="mb-2">
                <ListFilters handleFilter={handleFilters} isCourseFilter={true}/>
            </Row>
            <Row className="mt-4 mb-3">
                {
                    loading ? (
                        <NotFound>
                            <Spinner animation="border" variant="primary" style={{ width: '2rem', height: '2rem', borderWidth: '0.25em', borderRightColor: 'transparent' }} />
                        </NotFound>
                    ) : (
                        <>
                            {hashNews.length === 0 ? (
                                <NotFound>
                                    <FaBoxOpen className="iconNotFound"></FaBoxOpen>
                                    <div>Nenhum resultado encontrado</div>
                                </NotFound>
                            ) : (
                                <ListContent>
                                    {!!hashNews.length && hashNews.map((arrayMaterial: IMaterial[], index) => {
                                        return (
                                            <div key={index}>
                                                {arrayMaterial.map((material) => (
                                                    <CardCourse material={material} onDetails={handleCourseDetails} removeFavorite={handleRemoveFavorite}/>
                                                ))}
                                            </div>
                                        )
                                    })}
                                </ListContent>
                            )}
                        </>
                    )
                }
            </Row>
            <Row>
                {!loading && hashNews.length > 0 ? (
                    <PaginationList currentPage={currentPage} totalItems={totalItens} onPageChange={handlePageChange}></PaginationList>
                ) : (<></>)}
            </Row>
        </Container >
    )
}
